angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwMultipleLineEllipsis
     * @restrict EA
     * @description
     * Max-Height of the element should be defined in order to use this directive.
     */
    .directive('dpwMultipleLineEllipsis', [function () {
            return {
                scope: {},
                link: function (scope, element) {
                    scope.$watch( function () {
                        window.setTimeout(function () {
                            var elementScrollHeight = element[0].scrollHeight;
                            var ua = window.navigator.userAgent;

                            if ( ua.indexOf('Firefox') > -1 ) {
                                elementScrollHeight -= 2;
                            } else if ( isIE(ua) ) {
                                elementScrollHeight -= 1;
                            }

                            element.toggleClass(
                                'multiple-line-ellipsis',
                                elementScrollHeight > element.outerHeight()
                            );
                        }, 0);
                    });

                    function isIE(ua) {
                        return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Edge/') > -1;
                    }
                }
            };
        }]
    );